import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ErrorBoundary } from '../components/error-boundary'
import '../index.css'

export const Route = createRootRoute({
  component: () => (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  ),
  errorComponent: ({ error }) => {
    console.error('Route error:', error)
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-card rounded-lg border border-border p-6 text-center">
          <h2 className="text-xl font-semibold text-destructive mb-2">Route Error</h2>
          <p className="text-muted-foreground mb-4">
            Failed to load this page. Please try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Reload Page
          </button>
        </div>
      </div>
    )
  }
})